<template>
	<div>
		<div id="container" class="container">
			<myheader name="关于我们"></myheader>
			<div class="top-about-banner vcenter minwidth">
				<div class="mx1360 vcenter">
					<div class="text2">以科技重塑信任，让文化永续流传</div>
					<div class="text3">
						<p>
							我们相信，每一件承载着人类智慧与情感的艺术品，都应拥有一个清晰、可信、可流转的数字身份
						</p>
						<p>
							我们致力于融合前沿科技与专业智慧，构建一个公平、透明、高效的艺术经济新生态
						</p>
						<p>
							让沉睡的文化资产在全球范围内焕发新生
						</p>
					</div>
				</div>
			</div>

			<div class="about-imglist mx1360">
				<el-row :gutter="21" :type="colwrap ? '' : 'flex'">
					<el-col :xs="24" :sm="12" :md="12" :lg="6">
						<div class="item vcenter">
							<img src="@/static/new/z-about-img1.jpg" class="p cover" />
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="6">
						<div class="item n2 vcenter">
							<img src="@/static/new/z-about-img2.jpg" class="p cover" />
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="6">
						<div class="item vcenter">
							<img src="@/static/new/z-about-img3.jpg" class="p cover" />
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="6">
						<div class="item n2 vcenter">
							<img src="@/static/new/z-about-img4.jpg" class="p cover" />
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="about-lclist minwidth">
				<div class="mx1360 pd">
					<div class="title">我们的历程</div>
					<div class="sub-title">一个构想奠定了十个产业的基石</div>
					<ul class="list">
						<li>
							<div class="t1">2013·萌芽</div>
							<div class="t2">项目构思与团队组建</div>
							<div class="t3">汇聚行业专家、技术精英与法律顾问，确立以“科技+标准"解决艺术品资产化难题的核心路径。</div>
						</li>
						<li>
							<div class="t1">2024·奠基</div>
							<div class="t2">标准研制与平台开发</div>
							<div class="t3">联合江苏省艺术品行业协会，启动《工艺美术品价值评估体系》团体标准研制;同步开发一阶段“环太湖链”鉴证备案平台。</div>
						</li>
						<li>
							<div class="t1">2025·启航</div>
							<div class="t2">平台上线与生态构建</div>
							<div class="t3">一期平台正式上线，提供鉴证备案服务。启动艺术品经纪人培训计划，生态初具雏形。</div>
						</li>
						<li>
							<div class="t1">未来·展望</div>
							<div class="t2">成为全球领先的艺术经济基础设施</div>
							<div class="t3">将团体标准推向全国，上线二阶段“AI价值评估引擎"，并拓展艺术品金融服务，纳入江苏省“十五五"规划。</div>
						</li>
						<img src="@/static/new/icon-dsj.png" class="icon-dsj" />
					</ul>
				</div>
			</div>
			<div class="team-box mx1360">
				<div v-if="teamlist.length > 0" class="mx1360 about-tdlist">
					<div class="title">我们的团队</div>
					<div class="sub-title">融合深厚行业经验与前沿科技实力的跨界专家团队</div>
					<div class="list">
						<el-row :gutter="32" :type="colwrap ? '' : 'flex'">
							<el-col :xs="24" :sm="12" :md="12" :lg="6" v-for="v, k in teamlist" :key="k">
								<div class="item vcenter">
									<div class="w">
										<img :src="v.fileList[0].url" class="p cover">
										<div class="t">{{ v.title || '' }}</div>
										<div class="t2">{{ v.subtitle || '' }}</div>
										<div class="t3">{{ v.description || '' }}</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>


				<div v-if="prolist.length > 0" class="mx1360 about-tdlist">
					<div class="title">专家团队</div>
					<div class="sub-title">融合深厚行业经验与前沿科技实力的跨界专家团队</div>
					<div class="list">
						<el-row :gutter="32" :type="colwrap ? '' : 'flex'">
							<el-col :xs="24" :sm="12" :md="12" :lg="6" v-for="v, k in prolist" :key="k">
								<div class="item vcenter">
									<div class="w">
										<img :src="v.fileList[0].url" class="p cover">
										<div class="t">{{ v.title || '' }}</div>
										<div class="t2">{{ v.subtitle || '' }}</div>
										<div class="t3">{{ v.description || '' }}</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
			<div v-if="partnerlist.length > 0" class="about-jglist minwidth">
				<div class="mx1360 pd">
					<div class="title">权威指导与合作伙伴</div>
					<div class="list">
						<el-row :gutter="25" :type="colwrap ? '' : 'flex'">
							<el-col :xs="f_col(6) || 24" :sm="f_col(6) || 24" :md="f_col(6) || 12" :lg="6"
								v-for="v, k in partnerlist" :key="k">
								<div class="item vcenter">
									<img :src="v.fileList[0].url" class="p cover" />
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>

			<div class="about-hzhb vcenter">
				<div class="mx1360 about-bot-btn vcenter">
					<div class="vcenter">
						<div class="text1">与我们一起，共创未来</div>
						<div class="text2">
							<p>
								我们正在寻找充满激情的人才与志同道合的伙伴
							</p>
							<p>
								如果您也对用科技改变艺术世界充满热情，欢迎加入我们
							</p>
						</div>
					</div>
					<div class="align-c">
						<div @click="goPage('30')" class="btn cur curadm">查看开放职位</div>
						<div @click="goPage('31')" class="btn white cur curadm">成为我们的合作伙伴 >></div>
					</div>
				</div>
			</div>

			<myfooter></myfooter>
		</div>
	</div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js";
export default {
	data() {
		return {
			teamlist: [],
			prolist: [],
			partnerlist: [],

		}
	},
	mounted() {
		that = this;
		that.initData();
	},
	methods: {
		goPage(id) {
			util.tourl("/detail", { id: id, lm: "解决方案" })
		},
		initData() {
			ty.ajax('web/web/about-us', {}).then((result) => {
				that.teamlist = result.data.data1
				that.prolist = result.data.data2
				that.partnerlist = result.data.data3 || []
			});
		}
	},
}
</script>

<style lang="scss" scoped>
@import '../style.scss'; //所有页面公用
@import "./about.scss";
</style>